'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('proxy-holder-select', {
      url: '/voting/:voteId/record-proxy-votes/:ballotId/proxy-holder-select',
      template: '<proxy-holder-select></proxy-holder-select>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/ballot/proxy-holder-select/proxy-holder-select.routes.js